import './styles/Point.scss';


function Point(props) {
    const {
        label,
        desc,
    } = props;


    return (
    <div className="point">
        <div className="pointImg">
            <div className="pointImgOne">
                <div className="pointImgTwo"></div>
            </div>
        </div>
        <div className="pointText">
            <p className="label2">
                {label}
            </p>
            <p className="desc3">
                {desc}
            </p>
        </div>
    </div>
    )
}
            
export default Point;